<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Stećci tour – Mistery surrounded by beauty</h1>
    <div class='tourPic'>
      <img src='@/assets/cultours/tour1/01.jpg' />
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>
              It’s about mysterious middle ages, tombstones, amazing viewpoints,
              canyons, old monasteries and mountain way of life…
            </p>
            <p class='pasus'>
              This tour links central and northern region of Montenegro; it
              takes you from 50 to over 1500 meters above sea level and it
              conveys the essence of life in these areas over the last couple of
              centuries. The leitmotif and the inspiration for the tour are
              medieval tombstones – known as stećci – the remains of an epoch
              that had left many questions behind. Often located in stunning
              places they lead us in the best possible way through the region
              known for its natural beauties and mountain way of life.
            </p>
            <p class='pasus'></p>
            <p class='pasus'>
              We will visit a number of locations where stećci are situated,
              listen to the heartbeat of ancient times and enjoy the view on
              Komarnica and Piva rivers’ canyons now partially flooded by the
              artificial Piva lake, which will leave us breathless.
            </p>
            <p class='pasus'></p>
            <p class='pasus'>
              Before we arrive at stećci locations, we simply cannot miss the
              opportunity to visit the most famous Montenegrin monastery –
              Ostrog, carved into mountain rocks and gladly visited by members
              of all religions.
            </p>
            <p class='pasus'></p>
            <p class='pasus'>
              Somewhere in the middle of the tour, a perfect spot and a stunning
              viewpoint will be our chance to refresh, have lunch or just have a
              break before we continue further to stećci and new discoveries.
            </p>
            <p class='pasus'></p>
            <p class='pasus'>
              Another monastery with incredible story behind is on our way –
              Piva Monastery, located immediately above Piva Lake and carrying a
              completely different aura than the spectacular Ostrog.
            </p>
            <p class='pasus'></p>
            <p class='pasus'>
              This region is known for the cattle breeding way of life, dairy
              products, cheese and cream, lamb and veal, honey but also for the
              famous Piva Lake trout. All of these delicacies can be tasted
              during the tour.
            </p>
            <p class='pasus'></p>
            <p class='pasus'>
              While driving through this amazing landscape we will get to know
              rural Montenegro, rest our eyes and slowly dive into what is
              considered the essence of life in these still well preserved areas
              of Montenegro.
            </p>
            <p class='pasus'></p>
            <p class='pasus'>
              The sun is set already, the evening has come and we arrive back in
              Podgorica.
            </p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour: Private</p>
            <p class='pasus'>
              Availability: May/June – October (depending on weather conditions)
            </p>
            <p class='pasus'>Group size: 1-7</p>
            <p class='pasus'>
              Departure from: Podgorica/ for departures from other cities the
              price can be obtained on request
            </p>
            <p class='pasus'>Difficulty level: easy</p>
            <p class='pasus'>Duration: 11-12 h</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
          <div class='collapse' id='itinerary'>
            <ul class='square'>
              <li class='pasus'>
                8:30 a.m. - a pick up at your place of stay or at the place we
                agree upon.
              </li>
              <li class='pasus'>
                After a 45 minutes’ drive we arrive at the famous Ostrog
                Monastery where we will get to know in more detail the upper
                part of the complex and enjoy the view on Zeta River valley.
              </li>
              <li class='pasus'>
                After another 30 minutes we arrive at the second largest town in
                Montenegro – Niksic, where we have a closer look at the outdoor
                collection of stećci.
              </li>
              <li class='pasus'>
                We continue further and in one hour, we get to Piva region and a
                viewpoint over Komarnica River where we can have a bite or
                refresh and enjoy the stunning view.
              </li>
              <li class='pasus'>
                It’s two o’clock and we carry on until we reach Piva Monastery,
                built nearby Piva Lake, which in the seventies was moved to a
                new location stone by stone.
              </li>
              <li class='pasus'>
                After the visit to the Piva Monastery, we descend to a tiny town
                of Pluzine to slowly move upward along the mountain and arrive
                at our first viewpoint with stećci.
              </li>
              <li class='pasus'>
                We continue our drive over Piva plateau to reach the second
                locality with stećci and a nice mountain lookout.
              </li>
              <li class='pasus'>
                It’s late afternoon and time to descend the mountain while
                taking a few more walks or a stop to enjoy the unforgettable
                view on Piva canyon, if you wish so.
              </li>
              <li class='pasus'>
                We are back in Podgorica between 8 and 9 p.m.
              </li>
            </ul>
            <div class='tour-time'>
              <p> <i class='fas fa-clock'></i> 5 hours</p>
              <p> <i class='fas fa-route'></i> 270 km</p>
            </div>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'
            ><h4 class='titles'>Prices:</h4></a
          >
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li class='pasus'>1 person – 200 EUR</li>
              <li class='pasus'>2 persons – 120 EUR p/person</li>
              <li class='pasus'>3 persons – 85 EUR p/person</li>
              <li class='pasus'>4 persons – 70 EUR p/person</li>
              <li class='pasus'>5 persons - 85 EUR p/person</li>
              <li class='pasus'>6 persons – 75 EUR p/person</li>
              <li class='pasus'>7 persons – 70 EUR p/person</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'
            ><h4 class='titles'>Included in price:</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Driving by car/van</li>
              <li class='pasus'>Bottle of water</li>
              <li class='pasus'>Tourist tax at Ostrog Monastery</li>
              <li class='pasus'>Welcome drink</li>
              <li class='pasus'>Professional guiding service - English</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'
            ><h4 class='titles'>Practical info:</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>
                We recommend that you carry with you a jacket, a cap,
                sunglasses, some sweets and footwear adequate to conditions in
                the mountain area.
              </li>
              <li class='pasus'>
                We recommend purchasing authentic local products such as honey,
                tea, brandy or cheese.
              </li>
              <li class='pasus'>
                Prices of food and beverage in local restaurants are affordable.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'
            ><h4 class='titles'>Optional:</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
              <li class='pasus'>Additional walks during the tour</li>
              <li class='pasus'>
                Itinerary changes during the tour as agreed (do not affect the
                price)
              </li>
              <li class='pasus'>Lunch at local restaurant</li>
              <li class='pasus'>Visit to local farm</li>
              <li class='pasus'>Visit to local honey producer</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/cultours/tour1/01.jpg'),
          thumbnail: require('@/assets/cultours/tour1/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour1/02.jpg'),
          thumbnail: require('@/assets/cultours/tour1/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour1/03.jpg'),
          thumbnail: require('@/assets/cultours/tour1/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour1/04.jpg'),
          thumbnail: require('@/assets/cultours/tour1/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour1/05.jpg'),
          thumbnail: require('@/assets/cultours/tour1/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour1/06.jpg'),
          thumbnail: require('@/assets/cultours/tour1/06.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/CT1_Stecci.vue